import classes from "./SortButton.module.css";
import {useContext} from "react";
import QRCodeContext from "../../../../../contexts/qr-code/QRCodeContext";
import QRCodeViewSortingContext from "../QRCodeViewSortingContext";

type Props = {
    /**
     * Sort by key.
     * Item will be active, if sortBy is matching to value in QRCodeContext query
     * @since 0.1.9
     * @author Kacper Faber
     */
    sortBy: string;

    label: string;
}

function SortButton(props: Props) {
    /**
     * QRCodeContext
     * @since 0.1.9
     * @author Kacper Faber
     */
    const ctx = useContext(QRCodeContext);

    /**
     * QRCodeViewSortingContext - to control the popover
     * @since 0.1.9
     * @author Kacper Faber
     */
    const popoverCtx = useContext(QRCodeViewSortingContext);

    const getClassNames = () => {
        return `${classes.root} ${ctx.query.sortBy === props.sortBy ? classes.active : ''}`;
    }

    const onClick = () => {
        ctx.setQuery({...ctx.query, sortBy: props.sortBy});
        popoverCtx.setOpened(false);
    };

    return (
        <div className={getClassNames()} onClick={onClick}>
            { props.label }
        </div>
    );
}

export default SortButton;